import { createSlice } from '@reduxjs/toolkit';
const initialState = () => {
  return {
    hasFetched: false,
    isFetching: false,
    plots: [],
    worthwhileNumber: 150,
  };
};

const mapReducers = createSlice({
  name: 'map',
  initialState,
  reducers: {
    resetApp: () => {
      initialState();
    },
    receiveData: (state, action) => {
      state.hasFetched = true;
      state.isFetching = false;
      state.data = action.payload;
      return state;
    },
    setWorthwhileNumber: (state, action) => {
      state.worthwhileNumber = action.payload;
      return state;
    },
  },
});
export const { resetApp, receiveData, setWorthwhileNumber } =
  mapReducers.actions;
export default mapReducers.reducer;
